// @flow
import React from "react";

import {
  SelecaoCasasDecimais,
  SelecaoPeriodo,
  SelecaoPeriodicidade,
  SelecaoAjusteDias,
  SelecaoJanelaMovel,
} from "../configuracoes";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  getJanelaMovelSelecionada,
  analiseValorDaMedida,
} from "../../../state";
import { useSelector } from "react-redux";

export const processarPeriodoDiario = comGeradorDePeriodo((state, medidas) => {
  const edicaoMedida = getEdicaoMedida(state);
  const dataBase = getDataBaseSelecionadaAsString(state);
  const janelaMovel = getJanelaMovelSelecionada(state);
  const modoSeries = isModoSeries(state);

  if (modoSeries) {
    return medidas.map(medidaSelecionada => ({
      ...medidaSelecionada,
      descricaoSelecao: "",
      janelaMovel: janelaMovel,
      ...analiseValorDaMedida(medidaSelecionada, state),
    }));
  } else {
    return medidas.map(medidaSelecionada => ({
      ...medidaSelecionada,
      descricaoSelecao: "",
      periodicidade: edicaoMedida.periodicidade,
      ajusteDias: edicaoMedida.ajusteDias,
      dataBase: dataBase,
      janelaMovel: janelaMovel,
      ...analiseValorDaMedida(medidaSelecionada, state),
    }));
  }
});

const PeriodoDiario = () => {
  const modoSeries = useSelector(isModoSeries);

  if (modoSeries) {
    return (
      <>
        <div className="ConfiguracaoMedida">
          <SelecaoJanelaMovel />
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="ConfiguracaoMedida--flex">
          <SelecaoPeriodo exibirPeriodicidade={false} />
        </div>

        <div className="ConfiguracaoMedida">
          <div className="ConfiguracaoMedida__box">
            <SelecaoPeriodicidade />
          </div>

          <div className="ConfiguracaoMedida__box">
            <SelecaoAjusteDias />
          </div>
        </div>

        <SelecaoCasasDecimais />
      </>
    );
  }
};

export default PeriodoDiario;
